<template>
  <div class="post-page">
    <div class="post-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="post-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <main class="post-wrapper">
      <h1 class="post-title color-1-100 background-1-10-after" v-if="!pageEditMode">
        {{ post.data.title }}
      </h1>
      <textarea class="post-title"
                data-gramm_editor="false"
                placeholder="Page title"
                data-lpignore="true"
                v-if="pageEditMode && isGM()"
                rows="1"
                v-model="post.data.title"
                v-on:keydown="autoSize($event)">{{ post.data.title }}</textarea>
      <div class="post-content" v-if="!pageEditMode" v-html="post.data.content"></div>
      <vue-editor
              name="content"
              v-if="pageEditMode && isGM()"
              :editorToolbar="editorToolbar"
              class="post-content form-control form-control__editor"
              data-vv-name="Post content"
              useCustomImageHandler
              @imageAdded="handleImageAdded"
              v-model="post.data.content" />
    </main>
    <div class="post-modal" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="meta-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'terms-and-conditions',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      post: {
        title: '',
        description: '',
        data: {
          title: '',
          content: ''
        }
      },
      editorToolbar: [
        [{'header': [2, 3, 4, 5, 6, false]}],
        ['bold', 'italic', 'underline', 'strike', {'color': []}, {'background': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        ['blockquote', 'code-block', 'image', 'link'],
        [{'font': []}],
        [{'align': []}],
        ['clean']
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole'
    ])
  },
  methods: {
    updateLandingPage () {
      if (this.disableAPI) return
      this.$validator.validateAll()
      if (this.errors.items.length) return
      let body = JSON.stringify(this.post)
      let pageData = {
        slug: 'terms-and-conditions',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'terms-and-conditions',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'terms-and-conditions'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/terms-and-conditions', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.post = pageData
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.post.title = this.metaData.title
        this.post.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          this.pageEditMode = false
        }
        if (window.ga) {
          window.ga('set', 'contentGroup1', this.$router.currentRoute.name.includes('edit') ? 'ADMINISTRATION_AREA' : 'PUBLIC_PAGE')
          window.ga('send', 'pageview', {
            'page': location.pathname,
            'location': location.href,
            'title': document.title
          })
        }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/terms-and-conditions', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage()
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    closePopup () {
      this.pageMetaEdit = false
    },
    handleImageAdded: function (file, Editor, cursorLocation) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      let $this = this
      reader.onloadend = function () {
        $this.$prompt({
          'title': 'Image alt',
          'lbHide': true,
          'rbLabel': 'Ok'
        })
            .then(function (alt) {
              if (alt) {
                Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">')
              } else {
                Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">')
              }
            })
      }
    }
  },
  created () {
    this.getLandingPage()
  }
}
</script>

<style src="@/assets/scss/main/post.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// TermsAndConditions.vue?fa9abc80